import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { UserStore } from '@app/core/services/user/user.store'
import { PermissionService } from '@core/services/permission-service/permission-service'
import { canAccessEiBannerAdmin } from '../utils/banner-access'

/**
 * Gates the EI Banner admin surface.
 *
 * Fail closed: only campaign admin roles or an explicit `manage_ei_banner`
 * grant (or implicit full-access catalog) may enter. A missing IAM catalog
 * entry does not open the surface to every authenticated user.
 */
export const bannerAccessGuard: CanActivateFn = async () => {
    const permissionService = inject(PermissionService)
    const userStore = inject(UserStore)
    const router = inject(Router)

    await permissionService.getPermissionsBitwise()

    if (canAccessEiBannerAdmin(permissionService, userStore.getUserData()?.user_type)) {
        return true
    }

    await router.navigate(['/'])
    return false
}
